// extracted by mini-css-extract-plugin
export default {"wrapper":"ExtendedEditorNavBar_wrapper__GNp-y","link":"ExtendedEditorNavBar_link__ZvEAN","active":"ExtendedEditorNavBar_active__Orczb"};